import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"11.5\" fill=\"url(#a)\" fill-opacity=\".1\" stroke=\"#7800F8\" transform=\"matrix(0 1 1 0 -12 0)\"></circle><circle cx=\"7.2\" cy=\"7.2\" r=\"6.7\" stroke=\"#7800F8\" transform=\"matrix(0 1 1 0 -7.2 9.6)\"></circle><circle cx=\"4.2\" cy=\"4.2\" r=\"3.7\" stroke=\"#7800F8\" transform=\"matrix(0 1 1 0 -4.2 15.6)\"></circle><defs><linearGradient id=\"a\" x1=\"0\" x2=\"24\" y1=\"12\" y2=\"12\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#7800F8\"></stop><stop offset=\"1\" stop-color=\"#7800F8\" stop-opacity=\"0\"></stop></linearGradient></defs>", 4)
  ])))
}
export default { render: render }